import React, { useCallback } from "react";
import RightToLeft from "../../../../../../components/transitions/right-to-left";
import useStyles from "isomorphic-style-loader/useStyles";
import cls from './style.module.scss';
import ReactDOM from "react-dom";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import OrderRecommend from '../../detail/fragments/order-recommend/index';
import { useEffect } from "react";
import { fetchNotCommentOrders } from "../../../../../../../api";
import { fetchUnifiedProcessing } from "../../../../utils";
import { setCustomerLoading, action_fetch_order_detail, action_fetch_order_review, setCustomer } from "../../../../../../../store/actions/pages/customer";
import { useDispatch } from "react-redux";
import { Header } from "../../../../../../components/header";


export const ReviewSuccess = props =>{
	useStyles(cls);
	const { orderId, templateStr, onClose } = props;
	const Intl = useIntl();
	const history = useHistory();
	const [notCommentOrder, setNotCommentOrder] = useState(null);
	const dispatch = useDispatch();

	useEffect(async () =>{
		let response = await fetchNotCommentOrders(2);
		setNotCommentOrder(fetchUnifiedProcessing(response));
	}, [orderId]);

	const toReviewHandle = useCallback(async (evt, orderId) =>{
		evt.preventDefault();
		onClose?.();
		history.replace(`/user/order/review/${orderId}`);
		dispatch(setCustomerLoading(true));
		await dispatch(action_fetch_order_detail(orderId));
		await dispatch(action_fetch_order_review(orderId));
		dispatch(setCustomerLoading(false));
	}, []);

    return <div className={cls.ReviewSuccess}>
		<Header onClose={onClose} centerSlot={Intl.formatMessage({id: 'review', defaultMessage: 'Review'})}  />
		<div className={`${templateStr || notCommentOrder?.length > 0} ? ${cls.PaddingContainer} : ${cls.NoPadding}`}>
			{
				templateStr && <div className={cls.ReminderContainer}>
					<div dangerouslySetInnerHTML={{ __html: templateStr }}></div>

					<div className={cls.BtnContainer}>
						<a href="/"><FormattedMessage id="shop_now" defaultMessage="Shop Now" /></a>
						<Link to={`/user/credits`}><FormattedMessage id="get_more_points" defaultMessage="Get More points" /></Link>
					</div>
				</div>
			}

			{
				notCommentOrder?.length > 0 && <div className={cls.ReviewContainer}>
					<div className={cls.Hd}>
						<FormattedMessage id="also_awaiting_review" defaultMessage="These orders are also awaiting review" />
					</div>

					{
						notCommentOrder.map((reviewData, index)=>(
							<div className={cls.ReviewListItem} key={index+reviewData?.id}>
								<p className={cls.OrderNo}><FormattedMessage id="order_no" defaultMessage="Order No" />: {reviewData?.id}</p>

								<div className={cls.Images}>
									<div className={cls.Left}>
										{
											reviewData?.orderItems?.map((order, index)=>(
												<div className={cls.Image} key={index+order?.productId}>
													<img src={order?.productImageUrl} alt={`Review Image ${index}`} />
												</div>
											))
										}
									</div>

									<div className={cls.Right}>
										<a className={cls.Link} onClick={(e) =>toReviewHandle(e, reviewData?.id)}><FormattedMessage id="to_review" defaultMessage="To Review" /></a>
									</div>
								</div>
							</div>
						))
					}

					<div className={cls.Fd} onClick={() =>history.push(`/user/order/confirmed`)}>
						<span><FormattedMessage id="view_more" defaultMessage="View More" /> {'>'}</span>
					</div>
				</div>
			}
			
		</div>

		<OrderRecommend orderId={orderId} title={Intl.formatMessage({ id: "shop_the_reviewd_items", defaultMessage: "Shop the highly reviewed items" })} />
    </div>
}

const WrappedEditor = props => {
    useStyles(cls);
    const { show } = props;

	return <React.Fragment>
		<RightToLeft in={show} className={cls.ReviewSuccessModal}>
			<div>
                <ReviewSuccess {...props} />
			</div>
		</RightToLeft>
	</React.Fragment>
}

export default props =>{
    if (typeof window === 'undefined')
		return null

	return ReactDOM.createPortal(
		<WrappedEditor {...props} />,
		document.getElementById('root')
	)
}